import { useAppDispatch } from 'lib/redux'
import { deny } from 'lib/redux/permission'
import { Alert } from 'components/common'

export interface ErrorProps {
  message: string
}

export const Error = ({ message }: ErrorProps): JSX.Element => {
  const dispatch = useAppDispatch()

  // エラーメッセージを判別し表示する文言を権限エラーに変更
  if (message.match(/permission denied/)) {
    dispatch(deny())
  }

  return (
    <>
      <Alert message="エラー" description={message} type="error" showIcon />
    </>
  )
}
